module.exports = __webpack_public_path__ + "static/media/map2.fdca4a61.png";